import { render, staticRenderFns } from "./MHDatePicker.vue?vue&type=template&id=71b0c1a6&"
import script from "./MHDatePicker.vue?vue&type=script&lang=js&"
export * from "./MHDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports